import { Search } from '@mui/icons-material';
import api from './api';

export const authService = {
  // Login user
  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },

  // Register user (admin only)
  register: async (userData) => {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },

  // Logout user
  logout: async () => {
    const response = await api.post('/auth/logout');
    return response.data;
  },

  // Logout with refresh token
  logoutWithRefresh: async () => {
    const response = await api.post('/auth/logout-with-refresh');
    return response.data;
  },

  // Refresh token
  refreshToken: async () => {
    const response = await api.post('/auth/refresh');
    return response.data;
  },

  // Get current user info
  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  // Get current user profile
  getProfile: async () => {
    const response = await api.get('/auth/me/profile');
    return response.data;
  },

  // Get all users (admin only)
  getUsers: async (params = {}) => {
    const response = await api.get('/auth/users', {
      params: {
        page: params.page || 1,
        per_page: params.per_page || 10,
        search: params.search || '',
        status: params.status || '',
        ...params
      }
    });
    return response.data;
  },

  // Get user by username (admin only)
  getUserByUsername: async (username) => {
    const response = await api.get(`/auth/users/${username}`);
    return response.data;
  },

  // Change password
  changePassword: async (passwordData) => {
    const response = await api.post('/auth/change-password', passwordData);
    return response.data;
  },

  // Get public key
  getPublicKey: async () => {
    const response = await api.get('/auth/public-key');
    return response.data;
  },

  // OTP Login methods
  // Send OTP to phone number
  sendOtp: async (phoneNumber, purpose = 'login') => {
    const response = await api.post('/auth/otp/send', {
      phone_number: phoneNumber,
      purpose: purpose,
    });
    return response.data;
  },

  // Resend OTP to phone number
  resendOtp: async (phoneNumber, retrytype = 'text') => {
    const response = await api.post('/auth/otp/resend', {
      phone_number: phoneNumber,
      retrytype: retrytype,
    });
    return response.data;
  },

  // Verify OTP and authenticate user
  verifyOtp: async (phoneNumber, otp, purpose = 'login') => {
    const payload = {
      phone_number: phoneNumber,
      otp: otp,
      purpose: purpose,
    };
    const response = await api.post('/auth/otp/verify', payload);
    return response.data;
  },
};
